<template>
  <div>
    <DataNavigation></DataNavigation>
    <div class="index_content">
      <Layout>
        <Sider width="208">
          <div class="right_column">
            <p class="top-tip">产品数据</p>
            <div class="keyword-input">
              <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch($event)" />
            </div>
            <div class="rigit_title">
              <span>筛选</span>
              <Dropdown trigger="click" placement="bottom-start" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
                <a href="javascript:void(0)">
                  <span>{{screen_active}}</span>
                  <Icon type="md-arrow-dropup" v-if="drop_val" />
                  <Icon type="md-arrow-dropdown" v-else />
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem v-for="(item, sindex) in screen_dropdown" :name="item" :selected="screen_active == item" :key="sindex">{{item}}</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <div class="rigit_content">
              <div class="screen_ul">
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '产品类型'">
                  <div class="screen_tle" @click="screenTle.type = !screenTle.type">
                    <span>产品类型</span>
                    <Icon type="md-add" v-if="!screenTle.type" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.type">
                    <Checkbox v-model="checkAll.type" class="all_option" :disabled="checkAll.type" @on-change="handleCheckAll('type')">
                      <span>不限</span>
                    </Checkbox>
                    <CheckboxGroup v-model="params.type" @on-change="handleChangeOption($event, 'type')">
                      <Checkbox v-for="item,index of meta.product_type" :label="item.id" :key="index" v-show="index < 10 || showAll">
                        <span>{{item.name}}</span>
                      </Checkbox>
                    </CheckboxGroup>
                    <span class="more_sel" @click="showAll = !showAll" v-show="meta.product_type && meta.product_type.length > 10">
                      <template v-if="!showAll">查看更多</template>
                      <template v-else>收起更多</template>
                    </span>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '审批机构'">
                  <div class="screen_tle" @click="screenTle.org = !screenTle.org">
                    <span>审批机构</span>
                    <Icon type="md-add" v-if="!screenTle.org" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.org">
                    <RadioGroup v-model="params.org" vertical  @on-change="clearGetList">
                      <Radio label=""><span>不限</span></Radio>
                      <Radio v-for="item,key,index of meta.product_approval_org" :label="item" :key="key"><span>{{item}}</span></Radio>
                    </RadioGroup>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '获批时间'">
                  <div class="screen_tle" @click="screenTle.time = !screenTle.time">
                    <span>获批时间</span>
                    <Icon type="md-add" v-if="!screenTle.time" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.time">
                    <RadioGroup v-model="selTime" vertical @on-change="handleChangeTime($event)">
                      <Radio label=""><span>不限</span></Radio>
                      <Radio v-for="(item, index) in timeOption" :label="item" :key="index">
                        <span>{{item}}</span>
                      </Radio>
                      <Radio label="zdy"><span>自定义</span></Radio>
                    </RadioGroup>
                    <div class="zdy_time" v-if="selTime == 'zdy'">
                      <DatePicker type="date" v-model="params.s_time" placeholder="开始时间" :options="startOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                      <DatePicker type="date" v-model="params.e_time" placeholder="结束时间" :options="endOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                    </div>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '产品标签'">
                  <div class="screen_tle" @click="screenTle.tags = !screenTle.tags">
                    <span>产品标签</span>
                    <Icon type="md-add" v-if="!screenTle.tags" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.tags">
                    <Checkbox v-model="checkAll.tags" class="all_option" :disabled="checkAll.tags" @on-change="productTagsCheckNo">
                      <span>不限</span>
                    </Checkbox>
                    <CheckboxGroup v-model="view_tags" @on-change="productTagChangeOption($event, 'tags', 1)">
                      <div v-for="item,index of product_tags" :key="index" v-show="item.show_child" class="checkbox-div">
                        <Checkbox :label="item.id" :style="{transform: item.is_child?'translateX(20px)':'translateX(0)'}">
                          <span>{{item.name}}</span>
                        </Checkbox>
                        <Icon type="ios-arrow-forward" @click="OneTwo(item,'forward')" v-show="!item.is_child && !item.fa_show_child" />
                        <Icon type="ios-arrow-down" @click="OneTwo(item,'down')" v-show="!item.is_child && item.fa_show_child"/>
                      </div>
                    </CheckboxGroup>
                    <!-- <span class="more_sel" @click="showAll = !showAll" v-show="meta.getentityproducttag && meta.getentityproducttag.length > 10">
                      <template v-if="!showAll">查看更多</template>
                      <template v-else>收起更多</template>
                    </span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Sider>
        <Content>
          <div class="top-tip">全部
            <!-- <Dropdown @on-click="haddleChangeSort($event)">
              <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
              <DropdownMenu slot="list">
                <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
              </DropdownMenu>
            </Dropdown> -->
          </div>
          <div class="sel_opt" v-if="(haveOption && haveOption.length > 0) || fa_tags_selected.length > 0 || child_tags_selected.length > 0 || all_child_tags_selected.length > 0">
            <div class="sel_tle">已选条件</div>
            <div class="sel_cnt">
              <span v-for="(item,index) in haveOption" :key="index" @click="handleCancelOption(item)">{{item.name}}
                <Icon type="md-close" />
              </span>
              <!-- fa -->
              <span v-for="item in fa_tags_selected" :key="item" @click="delProductTag(item)">{{tagName(item, 'fa')}}
                <Icon type="md-close" />
              </span>
              <!-- ch -->
              <span v-for="item in child_tags_selected" :key="item" @click="delProductTag(item)">{{tagName(item, 'child')}}
                <Icon type="md-close" />
              </span>
              <!-- all-ch -->
              <span v-for="item in all_child_tags_selected" :key="item" @click="delProductTag(item)">{{tagName(item, 'all_child')}}
                <Icon type="md-close" />
              </span>
            </div>
            <div class="sel_clear">
              <span @click="handleClearOption()"><i class="iconfont">&#xe63e;</i>清空筛选</span>
            </div>
          </div>
          <div class="list_div">
            <Table :columns="listColumns" :data="listData"></Table>
            <OrgPrompt which="cpsj" v-if="listData.length == 5"></OrgPrompt>
            <Spin fix v-if="listLoading">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
          </div>
        </Content>
      </Layout>
    </div>
  </div>
</template>

<script>
import {
  productList
} from '../../service'
import {
  idxOf,
  remove,
  removeArrObj
} from 'js/findIndex'
import {
  listMixins
} from 'js/listMixins'
import {
  userInfo
} from 'js/userInfo'
import DataNavigation from './components/DataNavigation.vue'
import OrgPrompt from '@/components/OrgPrompt.vue'
import filter from 'js/filter'
import moment from 'moment'

export default {
  inject: ['login'],
  mixins: [listMixins, userInfo],
  components: {
    DataNavigation,
    OrgPrompt
  },
  data() {
    return {
      listName: '产品数据',
      listColumns: [
        {
          title: '企业名称',
          minWidth: 190,
          render: (h, params) => {
            return h('a',
              {
                on: {
                  click: () => {
                    this.goEntityDetail(params.row.entity_uid, params.row.entity_type, { active_name: 'product' })
                  }
                },
                class: {
                  'dec-clamp': true
                }
              },
              params.row.entity_short_name)
          }
        },
        {
          title: '产品名称',
          width: 190,
          render: (h, params) => {
            return h('div', filter.empty(params.row.title))
          }
        },
        {
          title: '产品详情',
          width: 250,
          render: (h, params) => {
            return h('div', {
              class: {
                'dec-clamp': true
              }
            }, filter.empty(params.row.description))
          }
        },
        {
          title: '产品类型',
          width: 120,
          render: (h, params) => {
            return h('span', filter.dealName(params.row.product_type_id, this.meta.product_type))
          }
        },
        {
          title: '审批机构',
          width: 100,
          render: (h, params) => {
            return h('div', filter.empty(params.row.approval_org))
          }
        },
        {
          title: '获批时间',
          width: 126,
          render: (h, params) => {
            return h('span', filter.timeTrans(params.row.approval_time))
          }
        }
      ],
      params: {
        user_key: '',
        type: [],
        tags: [],
        org: '',
        year: '',
        s_time: '',
        e_time: '',
        keyword: '',
        page: 1,
        sort_type: ''
      },
      screen_dropdown: ['全部', '产品类型', '审批机构', '获批时间', '产品标签'],
      //筛选条件是否展开
      screenTle: {
        org: false,
        type: false,
        tags: false,
        time: false
      },
      //不限
      checkAll: {
        type: true,
        tags: true
      },
      showAll: false,
      areasScope: 0,
      wholeScope: 0,
      chinaNum: 0,
      foreignNum: 0,
      yearNum: [],
      tagNum: [],
      countryNum: 0,
      availableNum: [],
      sort_id: 0,
      sort_list: [
        { id: 0, name: '获批时间倒序' },
        { id: 1, name: '获批时间正序' }
      ],
      position_id: '',

      view_tags: [],
      fa_tags: [],
      child_tags: [],
      fa_tags_selected: [], // 已经选择的一级菜单(元素是id)
      child_tags_selected: [], // 已经选择的二级菜单
      all_child_tags_selected: []
    }
  },
  computed: {
    haveOption() {
      let optionYear = [],
        optionStart = [],
        opitonEnd = [],
        optionKeyWord = [],
        optionOrg = [],
        optionType = [],
        optionTags = []

      this.params.type.map((a) => {
        optionType.push({
          type: 'type',
          name: filter.dealName(a, this.meta.product_type),
          value: a
        })
      })

      // this.params.tags.map((a) => {
      //   optionTags.push({
      //     type: 'tags',
      //     name: filter.dealName(a, this.meta.getentityproducttag),
      //     value: a
      //   })
      // })

      if (this.params.org !== '') {
        optionOrg = {
          type: 'org',
          name: this.params.org,
          value: this.params.org
        }
      }

      if (this.params.year != '' && this.selTime != 'zdy') {
        optionYear = {
          type: 'year',
          name: this.params.year,
          value: this.params.year
        }
      }
      if (this.params.s_time != '') {
        optionStart = {
          type: 's_time',
          name: '开始时间：' + filter.time_moment(this.params.s_time),
          value: this.params.s_time
        }
      }
      if (this.params.e_time != '') {
        opitonEnd = {
          type: 'e_time',
          name: '结束时间：' + filter.time_moment(this.params.e_time),
          value: this.params.e_time
        }
      }
      if (this.params.keyword !== '') {
        optionKeyWord = {
          type: 'keyword',
          name: this.params.keyword,
          value: this.params.keyword
        }
      }
      return [].concat(
        optionYear,
        optionStart,
        opitonEnd,
        optionKeyWord,
        optionOrg,
        optionType,
        optionTags
      )
    },
    product_tags() {
      if(this.meta.getentityproducttag) {
        let temp = {}
        for(let item of this.meta.getentityproducttag) {
          item['show_child'] = true
          if(item.pid) { // 二级
            item['is_child'] = true
            item['show_child'] = false
            if(item.pid in temp) {
              temp[item.pid].push(item)
            } else {
              temp[item.pid] = [{
                id: '-'+item.pid,
                name: '全部',
                pid: item.pid,
                is_child: true,
                show_child: false
              },item]
            }
            this.child_tags.push(item)
          } else { // 一级
            item['fa_show_child'] = false
            this.fa_tags.push(item.id)
          }
        }

        let temp_arr = this.meta.getentityproducttag.reduce((val, item) => {
          if(item.pid == null) {
            val.push(item)
          }
          if(temp.hasOwnProperty(item['id'])) {
            val = val.concat(temp[item.id])
            delete temp[item.id]
          }
          return val
        }, [])
        return temp_arr
      }
      return []
    }
  },
  methods: {
    /**
     * 获取列表
     */
    async getEntityList() {
      this.params.sort_type = this.sort_id
      this.params.user_key = this.user_key
      if(this.params.s_time) {
        this.params.s_time = moment(this.params.s_time).format('YYYY-MM-DD')
      }
      if(this.params.e_time) {
        this.params.e_time = moment(this.params.e_time).format('YYYY-MM-DD')
      }
      let temp_arr = [].concat(this.fa_tags_selected, this.child_tags_selected)
      if(this.all_child_tags_selected.length > 0) {
        for(let i of this.all_child_tags_selected) {
          temp_arr = temp_arr.concat(this.child_tags.filter(item => item.pid == i.substring(1)).map(item => item.id))
        }
      }
      this.params.tags = temp_arr
      this.listLoading = true
      let res = await productList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'listData', res.res)
        if (this.params.page == 1) {
          this.$set(this.$data, 'total', res.count)
        }
        this.listLoading = false
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 清空已选择项
     */
    handleClearOption(ref) {
      this.params = {
        type: [],
        tags: [],
        org: '',
        year: '',
        s_time: '',
        e_time: '',
        keyword: '',
        page: 1
      }
      this.checkAll = {
        type: true,
        tags: true
      }
      this.view_tags = []
      this.fa_tags_selected = []
      this.child_tags_selected = []
      this.all_child_tags_selected = []
      this.selTime = ''
      this.search_ipt = ''
      this.getEntityList()
    },
    /**
     * 产品标签筛选
     */
     productTagChangeOption(arr, typeName) {
      if (!this.listLoading) {
        if (arr.length > 0) {
          this.checkAll[typeName] = false
        } else {
          this.checkAll[typeName] = true
        }
        this.refreshFaData(arr)
        this.refreshChData(arr)
        this.refreshAllChData(arr)
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    refreshFaData(arr) {
      this.fa_tags_selected = arr.filter(item => this.fa_tags.includes(item))
    },
    refreshChData(arr) {
      this.child_tags_selected = arr.filter(item => this.child_tags.find(c => c.id == item))
    },
    refreshAllChData(arr) {
      this.all_child_tags_selected = arr.filter(item => this.child_tags.find(c => '-'+c.pid == item))
    },
    productTagsCheckNo() {
      if (!this.listLoading) {
        if (this.checkAll['tags']) {
          this.params['tags'] = []
        }
        this.view_tags = []
        this.refreshFaData(this.view_tags)
        this.refreshChData(this.view_tags)
        this.refreshAllChData(this.view_tags)
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    tagName(item, type) {
      if(type == 'fa') {
        return this.product_tags.find(i => i.id == item).name
      } else if(type == 'child') {
        return this.child_tags.find(i => i.id == item).name
      } else {
        return this.product_tags.find(i => i.id == item.substring(1)).name + '-全部'
      }
    },
    delProductTag(item) { // 点击删除筛选
      this.view_tags.splice(this.view_tags.findIndex(i => i == item), 1)
      this.refreshFaData(this.view_tags)
      this.refreshChData(this.view_tags)
      this.refreshAllChData(this.view_tags)
    },
    OneTwo(item, type) { // 展开和收起
      this.product_tags.find(i => i.id == item.id)['fa_show_child'] = type == 'down' ? false : true
      for(let x of this.product_tags.filter(i => i.pid == item.id)) {
        x['show_child'] = type == 'down' ? false : true
      }
      this.$forceUpdate()
    }
  },
  created() {
    if (this.$store.state.product_params != '') {
      this.params = { ...this.$store.state.product_params }
      this.params.page = 1
      this.sort_id = this.params.sort_type
    }
    this.getMeta2(['product_type', 'product_approval_org', 'getentityproducttag'])
    this.getEntityList()
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll('right_column', 10)
      }
      window.onresize = () => {
        this.listenerScroll('right_column', 10)
      }
    })
  },
  watch: {
    fa_tags_selected(val, old_val) { // 监听父，是为了展开勾选全部和关闭时取消勾选
      if(val.length == old_val.length) {
        return
      }
      // 找出两个数组的补集
      let e = val.filter(function(v){ return !(old_val.indexOf(v) > -1) })
        .concat(old_val.filter(function(v){ return !(val.indexOf(v) > -1)}))
      for(let item of this.product_tags) {
        if(e.includes(item.pid)) {
          if(val.length > old_val.length) { // 勾选全部
            // item['show_child'] = true
            if(this.view_tags.indexOf('-'+item.pid) == -1) {
              this.view_tags.push('-'+item.pid)
            }
          } else { // 需要取消掉已勾选的二级
            // item['show_child'] = false
            // if(this.view_tags.includes(item.id)) {
            //   this.view_tags.splice(this.view_tags.findIndex(x => x == item.id), 1)
            // }
            // if(this.view_tags.includes('-'+item.pid)) {
            //   this.view_tags.splice(this.view_tags.findIndex(x => x == '-'+item.pid), 1)
            // }
          }
          this.refreshChData(this.view_tags)
          this.refreshAllChData(this.view_tags)
        }
      }
      this.params.page = 1
      this.getEntityList()
    },
    child_tags_selected(val, old_val) { // 监听子，是为了在二级内部操作时，全部的勾选的和取消
      if(val.length == old_val.length) {
        return
      }
      let e = val.filter(function(v){ return !(old_val.indexOf(v) > -1) })
        .concat(old_val.filter(function(v){ return !(val.indexOf(v) > -1)}))[0]
      let fa_id = this.child_tags.find(item => item.id == e).pid
      if(val.length > old_val.length) { // 新增
        let index = this.view_tags.findIndex(item => item == '-'+fa_id) 
        if(index != -1) {
          this.view_tags.splice(index, 1)
          this.refreshChData(this.view_tags)
          this.refreshAllChData(this.view_tags)
        }
      }
      this.params.page = 1
      this.getEntityList()
    },
    all_child_tags_selected(val, old_val) { // 监听子，是为了在二级内部操作时，全部的勾选的和取消
      if(val.length == old_val.length) {
        return
      }
      let e = val.filter(function(v){ return !(old_val.indexOf(v) > -1) })
        .concat(old_val.filter(function(v){ return !(val.indexOf(v) > -1)}))[0]
      if(val.length > old_val.length) {
        let temp_arr = this.child_tags.filter(x => x.pid == e.substring(1)).map(x => x.id) // 找到所有该'全部'的子节点
        this.view_tags = this.view_tags.filter(item => {
          return !temp_arr.includes(item)
        })
        this.refreshChData(this.view_tags)
        this.refreshAllChData(this.view_tags)
      }
      this.params.page = 1
      this.getEntityList()
    }
  },
  destroyed() {
    window.onscroll = ''
    window.onresize = ''
  },
  beforeDestroy() {
    this.$store.commit('updateProductParams', this.params)
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus';
@import '~styles/dataList.stylus';
.checkbox-div
  position relative
  >>>.ivu-checkbox-wrapper
    margin-right: 20px
  i
    position absolute
    top 0
    right 0
    color #d5d5d5
    cursor pointer
  &+.checkbox-div
    margin-top 10px
</style>
